import React from 'react';
import { ColumnProps } from 'antd/lib/table';

import { User } from '@totem/components/cyberReview/dataTypes';
import { getRoleString } from '@totem/components/cyberReview/utilities';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

type Props = {
  users: User[];
  loading: boolean;
};
const UserSubTable = ({ users, loading }: Props) => {
  const columns: ColumnProps<User>[] = [
    {
      title: 'User',
      dataIndex: 'displayName',
      key: 'displayName',
      render: (_, record: User) => (
        <span>
          {record.firstName}&nbsp;
          {record.lastName}
        </span>
      ),
      className: 'tableAlignTop',
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.firstName === compB.firstName
          ? 0
          : compA.firstName > compB.firstName
            ? 1
            : -1,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (_, record: User) => <span>{record.email}</span>,
      className: 'tableAlignTop',
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        compA.email === compB.email ? 0 : compA.email > compB.email ? 1 : -1,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (_, user: User) => {
        const roleString = getRoleString(user.role);
        return <div>{roleString}</div>;
      },
      className: 'tableAlignTop',
      sortDirections: ['ascend', 'descend'],
    },
  ];

  const getData = () => {
    if (typeof users !== 'undefined' && users !== null) {
      return users;
    }
    return [];
  };

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={getData()}
      loading={loading}
      rowKey={(record) => record.id}
    />
  );
};

export default UserSubTable;
